export const RICH_TEXT_EDITOR_OUTPUT_FORMATS = [
  'text',
  'json',
  'html',
];

export const RICH_TEXT_EDITOR_AUTOFOCUS_TYPES = [
  'start',
  'end',
  'all',
];

export const RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS = [
  'https',
  'http',
  'ftp',
  'ftps',
  'sftp',
  'mailto',
];

export default {
  RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS,
  RICH_TEXT_EDITOR_OUTPUT_FORMATS,
  RICH_TEXT_EDITOR_AUTOFOCUS_TYPES,
};
